import cx from "classnames";
import * as React from "react";

interface QESWidgetDescriptionProps {
  className?: string;
}

/**
 * Renders a descriptive text for the widget in smaller, gray text. Used primarily in the Header
 */
export const QESWidgetDescription: React.FC<React.PropsWithChildren<QESWidgetDescriptionProps>> = ({
  children,
  className,
}) => {
  return (
    <p className={cx("qes-widget__description", className)}>
      {children}
    </p>
  );
};
